import React, { useEffect, useState } from 'react';
import { API } from '@/App';
import SurveyForm from '@/pages/SurveyForm';

const APP_HOSTS = new Set(['localhost', '127.0.0.1', new URL(process.env.REACT_APP_BACKEND_URL).hostname]);

// Root path: a custom survey domain (e.g. t2.example.com) opens that survey's generic entry page —
// the same SurveyForm entry flow as /go/:slug. Every other host keeps the normal home page.
export const HostEntryRoute = ({ fallback }) => {
  const host = window.location.hostname.toLowerCase();
  const [state, setState] = useState(APP_HOSTS.has(host) ? 'home' : 'checking');
  useEffect(() => {
    if (state !== 'checking') return;
    fetch(`${API}/public/entry?host=${encodeURIComponent(host)}`)
      .then((r) => setState(r.ok ? 'entry' : 'home'))
      .catch(() => setState('home'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (state === 'checking') return <div className="min-h-screen bg-[#F0F2F5]" data-testid="host-entry-checking" />;
  return state === 'entry' ? <SurveyForm entry={{ host }} /> : fallback;
};
